<template>
    <div>
        <div style="display: flex;">
            <div style="width: 30%; float: left;">
                <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
            </div>

            <div style="width: 70%; float: right;">
                <h3 style="text-transform: uppercase;">
                    {{ person_details.rep_header.trust_name }}
                </h3>
                <h1 style="text-transform: uppercase; text-decoration: underline;">
                    {{ person_details.rep_header.school_name }}
                </h1>
                <h4 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                    {{ person_details.rep_header.address }}
                </h4>
                <div style="font-weight: bold;">
                    <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                    <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email }}</span><br />
                    <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                </div>
            </div>
        </div>

        <div align="center">
            <br />
            <h2>Application Form for the Academic Year <u>{{ person_details.ay }}</u></h2>
        </div>
        <div class="">
            <div style="display: flex;">
                <div style="width: 25%; float: left;">
                    <h3 style="margin: 10px;">
                        Admission Form No.:&nbsp;{{ person_details.admission_form_no }}
                    </h3>
                    <div>
                        <h3 style="margin: 10px;">Admitted Class:&nbsp;{{ person_details.standard.field_value }}</h3>
                        <h3 style="margin: 10px;">Admitted No:&nbsp;___________</h3>
                        <!-- <h3 style="margin: 10px;">Admitted Year:&nbsp;{{ person_details.ay }}</h3> -->
                    </div>
                </div>
                <div style="width: 75%; float: right;">
                    <div class="photo" v-if="person_details.parent_photo">
                        <center>
                            <v-img width="150" :src="awspath + person_details.parent_photo" aspect-ratio="1" class="grey lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                            Parent`s Photo
                        </center>
                    </div>
                    <div class="photo">
                        <center>
                            <v-img width="150" :src="awspath + person_details.father_photo" aspect-ratio="1" class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                            Father`s Photo
                        </center>
                    </div>
                    <div class="photo">
                        <center>
                            <v-img width="150" :src="awspath + person_details.mother_photo" aspect-ratio="1" class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                            Mother`s Photo
                        </center>
                    </div>
                    <div class="photo">
                        <center>
                            <v-img
                                width="150"
                                :src="awspath +
                person_details.profile_image_path +
                person_details.profile_image_name
                "
                                aspect-ratio="1"
                                class="lighten-2"
                                style="border: 3px solid #1e4e78; border-radius: 10px;"
                            ></v-img>

                            Student`s Photo
                        </center>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" style="width: 105%;">
                <div class="row">
                   <div class="col-12">
                        <h3 style="color: #b04759;">Student Details</h3>
                    </div>
                    <div class="col-4 text-center stud_details" style="" v-if="person_details.firstname != null">
                        <b> First Name</b>&nbsp;<br>
                         {{ person_details.firstname.field_value }}
                    </div>
                    <div class="col-4 text-center stud_details" style="" v-if="person_details.middlename != null">
                        <b> Middle Name</b>&nbsp;<br>
                     {{ person_details.middlename.field_value }} 
                    </div>
                    <div class="col-4  text-center stud_details" style="" v-if="person_details.lastname != null">
                        <b> Last Name</b>&nbsp;<br>
                        {{ person_details.lastname.field_value }}
                    </div>
                    <div class="col-12 stud_details" v-if="person_details.fullname != null" style="">
                        <b> Full Name:</b>&nbsp;<br>
                         {{ person_details.fullname.field_value }}
                    </div>
                     <div class="col-3 text-center stud_details" style="" v-if="person_details.date_of_birth != null">
                        <b> {{ person_details.date_of_birth.field_display_name }}:</b>
                        {{ person_details.date_of_birth.field_value }}
                     </div>
                     <div class="col-6 text-center stud_details" style="" v-if="person_details.date_of_birth_in_words != null">
                        <b> {{ person_details.date_of_birth_in_words.field_display_name }}:</b>
                        {{ person_details.date_of_birth_in_words.field_value }}
                     </div>
                     <div class="col-3 text-center stud_details" style="" v-if="person_details.gender != null">
                        <b> {{ person_details.gender.field_display_name }}:</b> 
                        {{ person_details.gender.field_value }}
                     </div>
                      <div class="col-6 text-center stud_details" style="" v-if="person_details.birth_place != null">
                        <b> {{ person_details.birth_place.field_display_name }}: </b>{{ person_details.birth_place.field_value }}
                    </div>
                     <div class="col-6 text-center stud_details" style="" v-if="person_details.birthcountry != null">
                        <b> {{ person_details.birthcountry.field_display_name }}: </b> {{ person_details.birthcountry.field_value }}
                     </div>
                      <div class="col-4  text-center stud_details" style="" v-if="person_details.nationality != null">
                        <b> {{ person_details.nationality.field_display_name }}: </b>{{ person_details.nationality.field_value }}
                      </div>
                      <div class="col-4  text-center stud_details" style="" v-if="person_details.citizenship != null">
                        <b> {{ person_details.citizenship.field_display_name }}: </b>{{ person_details.citizenship.field_value }}
                      </div>
                      <div class="col-4  text-center stud_details" style="" v-if="person_details.religion != null">
                        <b> {{ person_details.religion.field_display_name }}: </b>{{ person_details.religion.field_value }}
                    </div>
                    <div class="col-4  text-center stud_details" style="" v-if="person_details.cast != null">
                        <b> {{ person_details.cast.field_display_name }}: </b>{{ person_details.cast.field_value }}
                    </div>
                    <div class="col-4  text-center stud_details" style="" v-if="person_details.category != null">
                        <b> {{ person_details.category.field_display_name }}: </b>{{ person_details.category.field_value }}
                    </div>
                    <div class="col-4  text-center stud_details" style="" v-if="person_details.sub_caste != null">
                        <b> {{ person_details.sub_caste.field_display_name }}: </b>{{ person_details.sub_caste.field_value }}
                    </div>
                     <div class="col-4  text-center stud_details" style="" v-if="person_details.mothertoungue != null">
                        <b> {{ person_details.mothertoungue.field_display_name }}: </b>{{ person_details.mothertoungue.field_value }}
                    </div>
                      <div class="col-4  text-center stud_details" style="" v-if="person_details.aadhar_no != null"><b> 
                        {{ person_details.aadhar_no.field_display_name }}: </b>{{ person_details.aadhar_no.field_value }}
                        </div>
                     <div class="col-4  text-center stud_details" style="" v-if="person_details.passport_no != null"><b>
                         {{ person_details.passport_no.field_display_name }}: </b>{{ person_details.passport_no.field_value }}
                    </div>
                    
                    <div class="col-4  text-center stud_details" style="" v-if="person_details.bloodgroup != null">
                        <b> {{ person_details.bloodgroup.field_display_name }}: </b>{{ person_details.bloodgroup.field_value }}
                    </div>
                    <div class="col-6  text-center stud_details" style="" v-if="person_details.mobile_no != null">
                        <b> Mobile No.: </b> {{ person_details.mobile_no }}
                    </div>
                     <div class="col-6  text-center stud_details" style="" v-if="person_details.personal_email != null">
                        <b> Primary Email: </b> {{person_details.personal_email }}
                    </div>
                     <div class="col-6  text-center stud_details"  v-if="person_details.is_single_girl_child != null">
                        <b> {{ person_details.is_single_girl_child.field_display_name }}: </b> {{ person_details.is_single_girl_child.field_value }}
                    </div>
                     <div class="col-6  text-center stud_details"  v-if="person_details.is_EWS != null ">
                        <b> {{ person_details.is_EWS.field_display_name }}: </b> {{ person_details.is_EWS.field_value }}
                    </div>
                     <div class="col-12  text-center stud_details"  v-if="person_details.father_full_name != null ">
                        <b> Father's Name: </b>   {{ person_details.fullname.field_value }}
                    </div>
                     <div class="col-12  text-center stud_details"  v-if="person_details.mother_first_name != null">
                        <b> Mother's Name: </b>  {{ person_details.mother_first_name.field_value }}
                    </div>
                    <div class="col-12 stud_details" style="" v-if="person_details.languages_known != null">
                            <b> {{ person_details.languages_known.field_display_name }} : </b>{{ person_details.languages_known.field_value }}
                    </div>
                    <h3 style="color: #b04759;">Previous School Attended</h3>
                     <div class="col-12 stud_details" style="" v-if="person_details.previous_school_name != null">
                            <b> School Name : </b> {{ person_details.previous_school_name.field_value }}
                    </div>
                    <div class="col-12 stud_details" style="" v-if="person_details.reason_for_leaving_last_school != null">
                        <b> Reason for leaving the School : </b> {{ person_details.reason_for_leaving_last_school.field_value }}   
                    </div>
                    <div class="col-6  text-center stud_details" style="" v-if="person_details.academic_program_studied != null"><b> 
                        {{ person_details.academic_program_studied.field_display_name }} : </b>
                        <span v-if="person_details.academic_program_studied.field_value">  {{ person_details.academic_program_studied.field_value }} </span>
                        <span v-else><br><br><br><br></span>
                    </div>
                    <div class="col-6  text-center stud_details" style="" v-if="person_details.previousschoolpassingstandard != null">
                        <b> Last Grade Attended : </b>
                        <span v-if="person_details.previousschoolpassingstandard.field_value"> {{person_details.previousschoolpassingstandard.field_value }}</span> 
                        <span v-else><br><br><br><br></span>
                    </div>
                    <div class="col-12">
                        <h3 style="color: #b04759;">Local/Current Address</h3>
                    </div>
                    <div class="col-3" v-if="person_details.local_address != null">
                        <b> Address</b> :
                    </div>
                    <div class="col-9" style="border-bottom: 2px solid black;" v-if="person_details.local_address != null">
                         <span v-if="person_details.local_address.laddress">
                        {{ person_details.local_address.laddress }}
                        </span> 
                        <span v-else>
                            <br>
                            <br>
                        </span>
                    </div>
                    <div class="col-3" v-if="person_details.local_address != null">
                        <b> City</b>
                    </div>
                    <div class="col-3" style="border-bottom: 2px solid black;"  v-if="person_details.local_address != null">
                           {{ person_details.local_address.lcity }}
                    </div>
                    <div class="col-3 text-center" v-if="person_details.local_address != null">
                        <b> State</b>
                    </div>
                    <div class="col-3" style="border-bottom: 2px solid black;"  v-if="person_details.local_address != null">
                       {{ person_details.local_address.lstate }}
                    </div>
                    <div class="col-3" v-if="person_details.local_address != null">
                        <b> Country</b>
                    </div>
                    <div class="col-3" style="border-bottom: 2px solid black;"  v-if="person_details.local_address != null">
                       {{ person_details.local_address.lcountry }}
                    </div>
                    <div class="col-3 text-center" v-if="person_details.local_address != null">
                         <b> Pin</b>
                    </div>
                    <div class="col-3" style="border-bottom: 2px solid black;"  v-if="person_details.local_address != null">
                      {{ person_details.local_address.lpin }}
                    </div>
                    <div class="col-12">
                        <h3 style="color: #b04759;">Permanent Address</h3>
                    </div>
                    <div class="col-3" v-if="person_details.permanent_address != null">
                        <b> Address</b> :
                    </div>
                    <div class="col-9" style="border-bottom: 2px solid black;" v-if="person_details.permanent_address != null">
                       <span v-if="person_details.permanent_address.paddress">
                        {{ person_details.permanent_address.paddress }}
                        </span> 
                        <span v-else>
                            <br>
                            <br>
                        </span>
                    </div>
                    <div class="col-3" v-if="person_details.permanent_address != null">
                        <b> City</b> 
                    </div>
                    <div class="col-3" style="border-bottom: 2px solid black;"  v-if="person_details.permanent_address != null">
                          {{ person_details.permanent_address.pcity }}
                    </div>
                    <div class="col-3 text-center" v-if="person_details.permanent_address != null">
                        <b> State</b>
                    </div>
                    <div class="col-3 " style="border-bottom: 2px solid black;"  v-if="person_details.permanent_address != null">
                       {{ person_details.permanent_address.pstate }}
                    </div>
                    <div class="col-3" v-if="person_details.permanent_address != null">
                        <b> Country</b>
                    </div>
                    <div class="col-3 " style="border-bottom: 2px solid black;"  v-if="person_details.permanent_address != null">
                       {{ person_details.permanent_address.pcountry }}
                    </div>
                    <div class="col-3 text-center" v-if="person_details.permanent_address != null">
                        <b> Pin</b>
                    </div>
                    <div class="col-3 " style="border-bottom: 2px solid black;"  v-if="person_details.permanent_address != null">
                       {{ person_details.permanent_address.ppin }}
                    </div>
                </div>
            </div>
        <div style="width: 109%;" class="">
            <v-row class="pagebreak">
                <br />
                <table class="" style="width: 100%;">
                    <br />
                    <tr>
                        <h3 style="color: #b04759;">Parent / Guardian Details</h3>
                    </tr>
                    <tr>
                        <td colspan="2" class="decoration" style="width: 30%; color: #b04759;"><b>Father Details</b></td>
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_father_details != null">
                            Father
                        </td> -->
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_mother_details != null">
                            Mother
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Name</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_full_name }}
                        </td>
                        <!-- 
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_full_name }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Contact No.</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_contact_no }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_contact_no }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Email</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_email }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_email }}
                        </td> -->
                    </tr>

                    <tr>
                        <td class="decoration"><b>Aadhar Card No.</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_aadharno }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Citizenship.</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_citizenship }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Nationality</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_nationality }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_nationality }}
                        </td> -->
                    </tr>

                    <tr>
                        <td class="decoration"><b>Qualification</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_education }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_education }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Occupation</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_occupation }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_occupation }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Designation</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_designation }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_designation }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration">
                            <b>Company/Organisation</b>
                        </td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details .relative_organization_name }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details .relative_organization_name }}
                        </td> -->
                    </tr>
                    <tr>
                        <td>
                            <b>Company/Organisation Address & Contact Details</b>
                        </td>

                        <td v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_office_address }}
                        </td>
                        <!-- <td v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_office_address }}
                        </td> -->
                    </tr>
                </table>
                <table class="" style="width: 100%;">
                    <!-- <br />
                    <tr>
                        <h3 style="color: #b04759;">Parent / Guardian Details</h3>
                    </tr> -->
                    <tr>
                        <td colspan="2" class="decoration" style="width: 30%; color: #b04759;"><b>Mother Details</b></td>
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_father_details != null">
                            Father
                        </td> -->
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_mother_details != null">
                            Mother
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Name</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_full_name }}
                        </td> -->

                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_full_name }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Contact No.</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_contact_no }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_contact_no }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Email</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_email }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_email }}
                        </td>
                    </tr>

                    <tr>
                        <td class="decoration"><b>Aadhar Card No.</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_aadharno }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Citizenship.</b></td>
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_citizenship }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Nationality</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_nationality }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_nationality }}
                        </td>
                    </tr>

                    <tr>
                        <td class="decoration"><b>Qualification</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_education }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_education }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Occupation</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_occupation }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_occupation }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Designation</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_designation }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_designation }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration">
                            <b>Company/Organisation</b>
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details .relative_organization_name }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details .relative_organization_name }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>Company/Organisation Address & Contact Details</b>
                        </td>

                        <!-- <td v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_office_address }}
                        </td> -->
                        <td v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_office_address }}
                        </td>
                    </tr>
                </table>
                <table style="width: 100%;">
                    <tr>
                        <td></td>
                        <td style="color: red;">
                            <b> Guardian Details - To be contacted in case of any emergency. [Note - Other than Parent] </b>
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_contact_name != null">
                        <td><b> Name</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_contact_name.field_value }}
                            <hr style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_contact_number != null">
                        <td><b> Contact No.</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_contact_number.field_value }}
                            <hr style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_email != null">
                        <td><b>Email</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_email.field_value }}
                            <hr style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>

                    <tr v-if="person_details.emergency_contact_address != null">
                        <td><b> Address</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_contact_address.field_value }}
                            <hr style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_relation != null">
                        <td><b>Relationship with the child</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_relation.field_value }}
                            <hr style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                </table>
                <v-simple-table
                    style="width: 100%;"
                    id="page"
                    v-if="person_details.relative_brother_details != null &&
        person_details.relative_mother_details != null
        "
                >
                    <tr>
                        <h3>Sibling Information</h3>
                    </tr>
                    <tr>
                        <th style="font-size: 14px;"></th>
                        <th v-if="person_details.relative_brother_details != null" style="font-size: 14px;">
                            Brother
                        </th>
                        <th v-if="person_details.relative_sister_details != null" style="font-size: 14px;">
                            Sister
                        </th>
                    </tr>
                    <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                    <tbody>
                        <tr>
                            <td><b>Name</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_full_name }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_full_name }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Aadhar No</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_aadharno }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_aadharno }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Education</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_education }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_education }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Annual Income</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_income }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_income }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Email</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_email }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_email }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Organisation</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details .relative_organization_name }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details .relative_organization_name }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Designation</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_designation }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_designation }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Office Address</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_office_address }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_office_address }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Contact No</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_contact_no }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_contact_no }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Nationality</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_nationality }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_nationality }}
                            </td>
                        </tr>
                        <hr style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Occupation</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_occupation }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_occupation }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-row>
        </div>
        <div class="pagebreak declaration_details">
            <v-row v-if="person_details.admission_instruction != null">
                <v-col
                    v-if="person_details.admission_instruction
            .admission_instructions_html_code != null
          "
                >
                    <div
                        v-html="person_details.admission_instruction
              .admission_instructions_html_code
            "
                    ></div>
                </v-col>
                <v-col
                    v-if="person_details.admission_instruction
            .admission_checklist_html_code != null
          "
                >
                    <div
                        v-html="person_details.admission_instruction.admission_checklist_html_code
            "
                    ></div>
                </v-col>
            </v-row>
        </div>
        <!-- </div> -->
        <div class="container">
            <div class="text-center">
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()" v-if="person_details != null">
                    <v-icon left>mdi-printer</v-icon>Print
                    <v-icon right></v-icon>
                </v-btn>
            </div>
            <!-- text-center -->
        </div>
    </div>
</template>

<script>
    export default {
        props: ["person_details"],
        created() {
            this.awspath = localStorage.getItem("awspath");
            this.tenant = localStorage.getItem("EPS-tenant");
            console.log("zeal");
        },
        methods: {
            print() {
                setTimeout(function () {
                    window.print();
                }, 100);
            },
        },
    };
</script>
<style scoped>
    .decoration {
        border-bottom: 1px solid black;
        border-width: 2px;
        padding-top: 5px;
    }
    td {
        padding-bottom: 2px !important;
    }
    #one_view_form {
        width: 1000px;
        height: 1400px;
        padding: 50px;
        padding-left: 5px;
        padding-right: 5px;
        margin: auto;
        padding: 13px;
    }

    .medical_details {
        margin-left: 3px;
    }

    td,
    th,
    tr {
        font-weight: normal !important;
        font-style: normal !important;
        font-size: 16px;
    }

    /* @media print {

  body {
   overflow: auto;
    height: auto; 
  }
} */
    @media print {
        /* .one_view_form {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  } */

        /* td,
  tr {
    font-weight: bold;
  } */

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        .textarea1 {
            background-color: red !important;
        }

        .pagebreak {
            page-break-before: always;
            padding-top: 5px !important;
        }

        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        body * {
            visibility: hidden;
        }
        td {
            padding-bottom: 10px;
        }

        #one_view_form * {
            visibility: visible;
            /* font-size: 17px;
    margin-left: 2px; */
        }

        /* .vvp-img {
    width: 170px !important;
  } */
    }

    /* .column {
  float: left;
  width: 50%;
  height: 40%;
  padding: 5px;
} */
    .row:after {
        content: "";
        display: table;
        clear: both;
    }

    #application_form {
        text-align: center;
        color: red;
        font-family: Arial;
        font-size: 130%;
        border: 2px solid blue;
        width: 230px;
    }

    /* shiv css  */
    .personal_details {
        border: 2px solid black;
        border-radius: 20px;
        padding-bottom: 5px;
    }

    .sib_table {
        border-bottom: 1px solid black !important;
    }

    .photo {
        margin: 10px;
        margin-top: 15px;
        margin-right: 15px;
        float: right;
    }

    @page {
        size: A4;
        margin-top: 0;
        padding-top: none;
        /* size: 15in 15.5in; */
        size: 11.5in 16.5in;
    }

    @page :first {
        margin-top: 15mm;
    }

    th:first-of-type {
        border-top-left-radius: 20px;
    }

    th:last-of-type {
        border-top-right-radius: 20px;
    }

    tr:last-of-type td:first-of-type {
        border-bottom-left-radius: 20px;
    }

    tr:last-of-type td:last-of-type {
        border-bottom-right-radius: 20px;
    }

    .declaration_details {
        font-size: larger;
    }

    .parent_details td,
    tr,
    th {
        font-size: 16px !important;
    }
    .jumbotron {
        font-family: "Nunito Sans" sans-serif;
        background: url("https://universal-wws-schoolerp.s3.ap-south-1.amazonaws.com/logo/uwws_background_admission_form.png") no-repeat center center;
        background-size: 100% 100%;
        height: 1590px;
        padding-top: 5%;
        padding-bottom: 1%;
    }
</style>
